import * as Y from 'yjs';

export function findBlockRecursive(blocks: Y.Array<any> | undefined, blockId: string): Y.Map<any> | null {
    if (!blocks) {
        return null;
    }
    for (const block of blocks.toArray()) {
        if (block instanceof Y.Map && block.get('id') === blockId) {
            return block as Y.Map<any>;
        }
        // Check if the block has children and if it's a Y.Array
        if (block instanceof Y.Map && block.has('children')) {
            const children = block.get('children');
            if (children instanceof Y.Array) {
                // Ensure children is Y.Array before recursive call
                const foundInChild = findBlockRecursive(children as Y.Array<any>, blockId);
                if (foundInChild) {
                    return foundInChild;
                }
            }
        }
    }
    return null;
}
